import reducer from './channel-collection-reducer';

export default reducer;
export { initialState } from './channel-collection-reducer';

export * from './channel-collection-actions';
